import { render, staticRenderFns } from "./informationDetailsArea.component.vue?vue&type=template&id=0d540be6"
import script from "./informationDetailsArea.component.ts?vue&type=script&lang=ts&external"
export * from "./informationDetailsArea.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports